<template>
    <div class="json-editor">
        <div class="json-editor__toolbar">
            <button type="button" class="btn btn-sm btn-outline-secondary me-2" @click="format">
                Format
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary" @click="minify">
                Minify
            </button>
            <span class="json-editor__status ms-3" :class="{'text-danger': !isValid, 'text-success': isValid}">
                {{ isValid ? 'Valid JSON' : (errorMessage || 'Invalid JSON') }}
            </span>
        </div>
        <textarea
            ref="textarea"
            class="form-control json-editor__textarea"
            :class="{'is-invalid': !isValid}"
            v-model="text"
            spellcheck="false"
            @input="onInput"
            @blur="onBlur"
        ></textarea>
    </div>
</template>

<script>
export default {
    name: 'json-editor',
    props: {
        modelValue: {
            type: [Object, Array, String],
            default: null,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            text: '',
            isValid: true,
            errorMessage: '',
        };
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(newValue) {
                this.syncFromModel(newValue);
            },
        },
    },
    methods: {
        syncFromModel(rawValue) {
            const incoming = this.toPrettyString(rawValue);
            if (this.isValid && this.text && this.normalize(this.text) === this.normalize(incoming)) {
                return;
            }
            this.text = incoming;
            this.isValid = true;
            this.errorMessage = '';
        },
        toPrettyString(rawValue) {
            if (rawValue === null || rawValue === undefined || rawValue === '') {
                return '{}';
            }
            if (typeof rawValue === 'string') {
                try {
                    return JSON.stringify(JSON.parse(rawValue), null, 2);
                } catch (e) {
                    return rawValue;
                }
            }
            try {
                return JSON.stringify(rawValue, null, 2);
            } catch (e) {
                return '{}';
            }
        },
        normalize(str) {
            try {
                return JSON.stringify(JSON.parse(str));
            } catch (e) {
                return str;
            }
        },
        parseAndEmit() {
            const raw = this.text.trim() === '' ? '{}' : this.text;
            try {
                const parsed = JSON.parse(raw);
                this.isValid = true;
                this.errorMessage = '';
                this.$emit('update:modelValue', JSON.stringify(parsed));
                return parsed;
            } catch (e) {
                this.isValid = false;
                this.errorMessage = e.message;
                return undefined;
            }
        },
        onInput() {
            this.parseAndEmit();
        },
        onBlur() {
            const parsed = this.parseAndEmit();
            if (parsed !== undefined) {
                this.text = JSON.stringify(parsed, null, 2);
            }
        },
        format() {
            const parsed = this.parseAndEmit();
            if (parsed !== undefined) {
                this.text = JSON.stringify(parsed, null, 2);
            }
        },
        minify() {
            const parsed = this.parseAndEmit();
            if (parsed !== undefined) {
                this.text = JSON.stringify(parsed);
            }
        },
    },
};
</script>

<style scoped>
.json-editor {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}
.json-editor__toolbar {
    display: flex;
    align-items: center;
}
.json-editor__textarea {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 0.875rem;
    min-height: 260px;
    white-space: pre;
    overflow: auto;
    tab-size: 2;
}
.json-editor__status {
    font-size: 0.85rem;
}
</style>
